/**
 * @generated SignedSource<<de28d6406f7082d8e2334935768b10d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type QuoteProviderMarkFinancingApplyClickedMutation$variables = {
  provider: string;
  quoteId: string;
};
export type QuoteProviderMarkFinancingApplyClickedMutation$data = {
  readonly markFinancingApplyClicked: {
    readonly financingApplyClickedAt: any | null;
    readonly financingApplyProvider: string | null;
    readonly id: string;
  } | null;
};
export type QuoteProviderMarkFinancingApplyClickedMutation = {
  response: QuoteProviderMarkFinancingApplyClickedMutation$data;
  variables: QuoteProviderMarkFinancingApplyClickedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "provider"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "quoteId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "provider",
        "variableName": "provider"
      },
      {
        "kind": "Variable",
        "name": "quoteId",
        "variableName": "quoteId"
      }
    ],
    "concreteType": "Quote",
    "kind": "LinkedField",
    "name": "markFinancingApplyClicked",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "financingApplyClickedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "financingApplyProvider",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "QuoteProviderMarkFinancingApplyClickedMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "QuoteProviderMarkFinancingApplyClickedMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4abcb4e88738609bd427b516e05827c5",
    "id": null,
    "metadata": {},
    "name": "QuoteProviderMarkFinancingApplyClickedMutation",
    "operationKind": "mutation",
    "text": "mutation QuoteProviderMarkFinancingApplyClickedMutation(\n  $quoteId: ID!\n  $provider: String!\n) {\n  markFinancingApplyClicked(quoteId: $quoteId, provider: $provider) {\n    id\n    financingApplyClickedAt\n    financingApplyProvider\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff24a3d473dd225dad10f3116235d702";

export default node;
